/**
 * RFC-4122 v4 UUID that works outside a secure context.
 *
 * `crypto.randomUUID()` is only defined in secure contexts (HTTPS or
 * localhost), so it is `undefined` when the app is served over plain HTTP on a
 * LAN / VPN host (e.g. a Tailscale MagicDNS name). `crypto.getRandomValues()`,
 * by contrast, IS available in insecure contexts — so we fall back to building
 * a v4 UUID from it. Prefer the native generator when present.
 */
export function uuid(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID()
  }

  const bytes = new Uint8Array(16)
  crypto.getRandomValues(bytes)
  // Set the version (4) and variant (10xx) bits. Arithmetic forms of
  // `(b & 0x0f) | 0x40` and `(b & 0x3f) | 0x80` (the low bits never overlap the
  // set bit), avoiding bitwise operators.
  bytes[6] = (bytes[6] % 0x10) + 0x40
  bytes[8] = (bytes[8] % 0x40) + 0x80

  const hex: string[] = []
  for (let i = 0; i < 256; i++) {
    hex.push((i + 0x100).toString(16).slice(1))
  }

  return (
    hex[bytes[0]] +
    hex[bytes[1]] +
    hex[bytes[2]] +
    hex[bytes[3]] +
    '-' +
    hex[bytes[4]] +
    hex[bytes[5]] +
    '-' +
    hex[bytes[6]] +
    hex[bytes[7]] +
    '-' +
    hex[bytes[8]] +
    hex[bytes[9]] +
    '-' +
    hex[bytes[10]] +
    hex[bytes[11]] +
    hex[bytes[12]] +
    hex[bytes[13]] +
    hex[bytes[14]] +
    hex[bytes[15]]
  )
}
